module.exports = __webpack_public_path__ + "static/landing_ThatsMe-e7e36a86434af2762034f6732eff1fc5.jpg";